import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import AIChatWidget from './components/AIChatWidget';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Contact from './pages/Contact';
import AdminDashboard from './pages/AdminDashboard';
import MyApplications from './pages/MyApplications';
import './App.css';
import './pages/ServicePage.css';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <ScrollToTop />
        <Navbar />
        <AIChatWidget />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          
          {/* Service Pages */}
          <Route path="/services/hotel" element={<ServicePage service="hotel" />} />
          <Route path="/services/networks" element={<ServicePage service="networks" />} />
          <Route path="/services/automation" element={<ServicePage service="automation" />} />
          <Route path="/services/video" element={<ServicePage service="video" />} />
          <Route path="/services/wifi" element={<ServicePage service="wifi" />} />
          <Route path="/services/telephony" element={<ServicePage service="telephony" />} />
          <Route path="/services/tv" element={<ServicePage service="tv" />} />
          <Route path="/services/servers" element={<ServicePage service="servers" />} />
          <Route path="/services/barrier" element={<ServicePage service="barrier" />} />
          <Route path="/services/access" element={<ServicePage service="access" />} />
          <Route path="/services/workplaces" element={<ServicePage service="workplaces" />} />
          <Route path="/services/equipment" element={<ServicePage service="equipment" />} />
          
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-applications"
            element={
              <ProtectedRoute>
                <MyApplications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute superAdminOnly={true}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Footer />
      </div>
    </AuthProvider>
  );
}

// About Page Component
const About = () => (
  <div className="about-page" style={{ paddingTop: '70px', minHeight: '100vh' }}>
    <div className="about-hero" style={{
      background: 'linear-gradient(135deg, #0a1628 0%, #1a365d 100%)',
      padding: '80px 20px',
      textAlign: 'center',
      color: '#ffffff'
    }}>
      <h1 style={{ fontSize: 'clamp(32px, 5vw, 48px)', fontWeight: 800, marginBottom: '16px' }}>
        О компании <span style={{
          background: 'linear-gradient(135deg, #3b82f6, #10b981)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>СЕТЬМОНТАЖ</span>
      </h1>
      <p style={{ fontSize: '18px', color: '#94a3b8', maxWidth: '700px', margin: '0 auto' }}>
        15 лет создаём цифровую инфраструктуру на Черноморском побережье
      </p>
    </div>
    <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '60px 20px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '30px', marginBottom: '60px' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', fontWeight: 800, background: 'linear-gradient(135deg, #3b82f6, #10b981)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>500+</div>
          <div style={{ color: '#64748b', marginTop: '8px' }}>успешных проектов</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', fontWeight: 800, background: 'linear-gradient(135deg, #3b82f6, #10b981)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>15</div>
          <div style={{ color: '#64748b', marginTop: '8px' }}>лет опыта</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', fontWeight: 800, background: 'linear-gradient(135deg, #3b82f6, #10b981)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>24/7</div>
          <div style={{ color: '#64748b', marginTop: '8px' }}>поддержка</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', fontWeight: 800, background: 'linear-gradient(135deg, #3b82f6, #10b981)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>300+</div>
          <div style={{ color: '#64748b', marginTop: '8px' }}>систем видеонаблюдения</div>
        </div>
      </div>
      
      <div style={{ background: '#f8fafc', borderRadius: '16px', padding: '40px', marginBottom: '40px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 700, color: '#0f172a', marginBottom: '20px' }}>Наша история</h2>
        <p style={{ color: '#475569', lineHeight: 1.8, marginBottom: '16px' }}>
          ООО «СЕТЬМОНТАЖ» работает на рынке IT-услуг с 2011 года. За это время мы реализовали более 500 успешных проектов
          на Черноморском побережье — от Анапы до Сочи.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.8 }}>
          Наша компания специализируется на комплексном обслуживании: от проектирования до обслуживания сложных IT-систем
          и слаботочных сетей. Мы учитываем особенности курортного региона — влажность и солёный воздух — и подбираем
          оборудование, которое надёжно работает в этих условиях.
        </p>
      </div>

      <div style={{ background: '#f8fafc', borderRadius: '16px', padding: '40px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 700, color: '#0f172a', marginBottom: '20px' }}>Руководство</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'linear-gradient(135deg, #3b82f6, #10b981)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '32px', color: '#ffffff', fontWeight: 700 }}>
            ДО
          </div>
          <div>
            <div style={{ fontSize: '18px', fontWeight: 700, color: '#0f172a' }}>Обухов Дмитрий Игоревич</div>
            <div style={{ color: '#64748b' }}>Генеральный директор</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

// Service Page Component
const serviceData = {
  hotel: {
    icon: '🏨',
    title: 'Гостиничные решения',
    description: 'Единая экосистема для курортных отелей Черноморского побережья',
    fullDescription: 'Комплексные решения для гостиниц от Анапы до Сочи. Учитываем сезонность, влажность, солёный воздух и требования международных гостей. Оснащено более 50 гостиниц — от гостевых домов до крупных комплексов.',
    features: [
      'Умные номера: автоматическое управление климатом, освещением, шторами, мультимедиа одним касанием',
      'Гостиничная телефония: внутренняя связь, автоподбор линий, учёт звонков',
      'IP-телевидение: мультиязычные каналы, видео по запросу, персональные приветствия',
      'СКС и Wi-Fi: бесшовный роуминг, гостевые порталы авторизации',
      'Системы безопасности: видеонаблюдение, контроль доступа, пожарная сигнализация',
      'Онлайн-бронирование, электронные ключи, автоматизация услуг',
      'Мобильное управление всеми системами через приложение',
      'Мониторинг энергопотребления и загрузки номерного фонда',
      'Интеграция с PMS (системы управления отелем)',
      'Объединение всех подсистем в единую платформу'
    ],
    stats: ['50+ гостиниц оснащено', 'Снижение расходов на 30%', '95% клиентов рекомендуют', 'Гарантия 3 года'],
    cta: 'Оснащено более 50 гостиниц. 95% клиентов рекомендуют наши решения.'
  },
  networks: {
    icon: '🌐',
    title: 'Сети и коммуникации',
    description: 'Проектирование, монтаж и обслуживание структурированных кабельных систем до 100 Гбит/с',
    fullDescription: 'Полный цикл работ: от проектирования до круглосуточного обслуживания. Построено более 500 км локальных сетей, восстановлено более 200 км повреждённых линий. Среднее время аварийного ремонта — 2 часа.',
    features: [
      'СКС: проектирование и монтаж по международным стандартам',
      'ЛВС: развёртывание сетей от 100 Мбит/с до 100 Гбит/с',
      'ВОЛС: сварка, диагностика, ремонт оптоволоконных линий',
      'Беспроводные сети: Wi-Fi 6/6E, мосты «точка-точка», Mesh-сети',
      'Аварийный ремонт: выезд в течение 2 часов (Новороссийск)',
      'Круглосуточный мониторинг и обслуживание',
      'Медные кабели: Cat.5e, Cat.6, Cat.6a, Cat.7, Cat.8',
      'Оптоволокно: многомодовое OM3/OM4/OM5, одномодовое OS1/OS2',
      'Питание: PoE, PoE+, PoE++',
      'Сварочные аппараты Fujikura 70S, лаборатория OTDR'
    ],
    stats: ['500+ км сетей построено', '200+ км восстановлено', 'Точность сварки 0.02 дБ', 'Ремонт за 2 часа'],
    cta: 'Диагностика сети БЕСПЛАТНО при заказе монтажных работ.'
  },
  automation: {
    icon: '🏠',
    title: 'Автоматизация',
    description: 'Умный дом и промышленная автоматизация с экономией энергии до 40%',
    fullDescription: 'Автоматизация любых процессов — от умных домов до промышленных предприятий. Реализовано более 200 объектов: от курортных вилл до цехов Новороссийского порта. Используем PLC, SCADA, KNX, Modbus, BACnet.',
    features: [
      'Инженерные системы: освещение, отопление, вентиляция, водоснабжение',
      'Промышленное оборудование: станки, конвейеры, системы контроля качества',
      'Безопасность: интеграция видеонаблюдения, СКУД, пожарной сигнализации',
      'Коммуникации: телефония, системы оповещения, переговорные устройства',
      'Умный микроклимат с адаптацией под погоду побережья',
      'Оптимизация потребления ресурсов до 40%',
      'Винодельческие предприятия: контроль температуры и влажности',
      'Портовые терминалы: автоматический учёт грузов с интеграцией в 1С',
      'Siemens LOGO/S7, Schneider Electric, KNX/EIB, Modbus RTU/TCP, BACnet/IP',
      'Снижение ошибок на 95%, рост производительности на 30%'
    ],
    stats: ['200+ объектов', 'Экономия энергии 40%', 'Снижение ошибок 95%', 'Рост производительности 30%'],
    cta: 'Бесплатный аудит автоматизации вашего объекта.'
  },
  video: {
    icon: '📹',
    title: 'Видеонаблюдение',
    description: 'Профессиональные системы видеонаблюдения «под ключ» с интеллектуальной аналитикой',
    fullDescription: 'Более 300 реализованных систем на Черноморском побережье. Разрешение 4K, распознавание лиц и номеров на расстоянии до 50 метров. Специальная защита оборудования от коррозии и влажности.',
    features: [
      'Разрешение камер: 4K Ultra HD',
      'Дальность распознавания: автомобильные номера и лица до 50 метров',
      'Интеллектуальная видеоаналитика: детекция движения, подсчёт людей, распознавание лиц',
      'Удалённый мониторинг: просмотр в реальном времени с телефона, планшета, ПК',
      'Архивирование: хранение записей от 30 суток на серверах или в облаке',
      'Специальная защита от коррозии, влажности и перепадов температур',
      'Предмонтажная подготовка с дополнительной защитной обработкой',
      'Интеграция с СКУД, умным домом, шлагбаумами и пожарной сигнализацией',
      'Облачные решения без капитальных затрат',
      'Проектирование, подбор оборудования, монтаж, круглосуточное ТО'
    ],
    stats: ['300+ систем установлено', '4K разрешение', 'До 50 метров распознавание', '30+ суток архив'],
    cta: 'Более 300 систем видеонаблюдения на Черноморском побережье.'
  },
  wifi: {
    icon: '📶',
    title: 'Wi-Fi и HotSpot',
    description: 'Бесшовные беспроводные сети для отелей, баз отдыха и массовых мероприятий',
    fullDescription: 'Организация беспроводных сетей с бесшовным роумингом по всей территории объекта. Гибкая авторизация: по звонку, SMS или ваучеру. Оптимизировано для отелей и массовых мероприятий.',
    features: [
      'Бесшовный WiFi роуминг по всей территории объекта',
      'Гибкая авторизация: по звонку, SMS или ваучеру',
      'Гостевые порталы авторизации с брендированием',
      'Интеграция в единую экосистему отеля (СКС и Wi-Fi)',
      'Wi-Fi 6/6E для высокой плотности подключений',
      'Мосты «точка-точка» для соединения зданий',
      'Mesh-сети для быстрого развёртывания',
      'Мониторинг нагрузки и автоматическое распределение',
      'Защита от несанкционированного доступа',
      'Аналитика подключений и поведения пользователей'
    ],
    stats: ['Бесшовный роуминг', 'Авторизация по звонку/SMS', 'Wi-Fi 6/6E', 'Для отелей и мероприятий'],
    cta: 'Бесшовное покрытие WiFi для вашего объекта.'
  },
  telephony: {
    icon: '📞',
    title: 'Телефония',
    description: 'Корпоративная IP-телефония с интеграцией в CRM — более 200 внедрений',
    fullDescription: 'От простых офисных систем до распределённых с интеграцией в CRM/ERP. Платформы: Asterisk, FreePBX, облачные АТС. Более 200 внедрённых систем от 10 до 1000 абонентов. Тест-драйв 7 дней бесплатно.',
    features: [
      'IP-АТС на базе Asterisk, FreePBX',
      'Локальные и облачные АТС',
      'Виртуальная АТС: только софтфон и гарнитура',
      'Колл-центры под ключ',
      'Интеграция с CRM: pop-up карточки клиента при входящем',
      'Интеграция с 1С, Битрикс24, системами бронирования',
      'Видеоконференции: HD-качество, до 100 участников',
      'Мобильные приложения для звонков с рабочего номера',
      'Система аналитики звонков: статистика, отслеживание эффективности',
      'Многоканальные номера: 8-800, городские, мобильные'
    ],
    stats: ['200+ внедрений', 'До 1000 абонентов', 'Снижение потерь 40%', 'Тест-драйв 7 дней'],
    cta: 'Тест-драйв на 7 дней БЕСПЛАТНО. Снижение потерь звонков на 40%.'
  },
  tv: {
    icon: '📺',
    title: 'Телевидение',
    description: 'IP-TV, DVB-T2, спутниковое и кабельное ТВ для гостиниц и бизнеса',
    fullDescription: 'Более 5000 установленных ТВ-приёмников, 200+ гостиничных систем. Собственные усилители сигнала, адаптированные к приморскому климату. Доступность сигнала 99.9%. FULL HD и 4K качество.',
    features: [
      'Форматы: IP-TV, DVB-T2, спутниковое ТВ, кабельное ТВ, OTT-сервисы',
      'Качество: FULL HD и 4K, HD для DVB-T2',
      'Собственные усилители сигнала для приморского климата',
      'Системы резервирования для непрерывной работы',
      'Доступность сигнала: 99.9%',
      'Мультирумные системы: разные каналы в разных комнатах',
      'Video on Demand — тысячи фильмов и сериалов по запросу',
      'Мультиязычность: каналы для иностранных туристов',
      'Welcome TV и платные каналы для гостиниц',
      'Удалённое администрирование списка каналов'
    ],
    stats: ['5000+ ТВ-приёмников', '200+ гостиничных систем', '99.9% доступность', 'FULL HD и 4K'],
    cta: 'Более 5000 установленных приёмников. Бесплатный подбор оптимального пакета.'
  },
  servers: {
    icon: '🖥️',
    title: 'Серверные комнаты',
    description: 'Проектирование и строительство от серверной стойки до полноценного ЦОД',
    fullDescription: 'Более 100 проектов: от офисных IT-шкафов до корпоративных и гостиничных ЦОД. Uptime 99.98%, PUE 1.4, уровень надёжности Tier II–III. Автономность до 24 часов.',
    features: [
      'Проектирование: расчёт нагрузок, тепловыделения, вентиляции, электроснабжения',
      'Строительные работы: фальшполы, фальшпотолки, противопожарные системы',
      'Климат-контроль: прецизионные кондиционеры с контролем влажности',
      'Электроснабжение: ИБП, дизель-генераторы, гарантированное питание',
      'Сетевая инфраструктура: патч-панели, коммутаторы, маршрутизаторы',
      'Мониторинг 24/7: контроль температуры, влажности, физического доступа',
      'Uptime: 99.98%, PUE 1.4, Tier II–III',
      'Температура: ±1°C, влажность: ±5%',
      'Автономность: ИБП + генераторы, резерв до 24 часов',
      'Спец. воздушные фильтры, антикоррозийные покрытия, дублирование систем'
    ],
    stats: ['100+ проектов', 'Uptime 99.98%', 'PUE 1.4', 'Автономность 24 часа'],
    cta: 'Бесплатный аудит существующей серверной комнаты.'
  },
  barrier: {
    icon: '🚧',
    title: 'Умный шлагбаум',
    description: 'Интеллектуальный контроль доступа с распознаванием номеров 99.7%',
    fullDescription: 'Более 300 установленных систем. Распознавание номеров с точностью 99.7% даже при плохом освещении. Ресурс привода 1 000 000 циклов — в 3 раза выше аналогов. Антикоррозийное покрытие всех элементов.',
    features: [
      'Распознавание номеров с точностью 99.7% при любом освещении',
      'Интеграция с системами бронирования: автоматический доступ гостям',
      'Резервные системы при отключении электроэнергии и интернета',
      'Фиксация и хранение истории проездов',
      'Мобильное приложение (iOS, Android) и веб-интерфейс',
      'Ваучерная система: одноразовые и многоразовые коды/QR-коды',
      'RFID-карты и брелоки',
      'Дистанционный пульт охраны',
      'Управление с планшета или компьютера',
      'Ресурс привода: 1 000 000 циклов, антивандальная защита'
    ],
    stats: ['300+ систем', 'Точность 99.7%', '1 000 000 циклов ресурса', '50 000 изображений в базе'],
    cta: 'Бесплатная доставка и предоставление демонстрационного образца.'
  },
  access: {
    icon: '🔐',
    title: 'Контроль доступа',
    description: 'СКУД и биометрические системы — более 400 установленных систем',
    fullDescription: 'От подъездных домофонов до интегрированных СКУД для промышленных предприятий и гостиниц. Надёжность 99.99%, 0 несанкционированных проходов. Биометрия, мобильные ключи, интеграция с PMS.',
    features: [
      'Домофонные системы: аудио- и видеодомофоны, многоабонентские',
      'Турникеты и триподы: контроль прохода, учёт рабочего времени',
      'Электромеханические замки: контроль доступа в отдельные помещения',
      'Системы учёта рабочего времени: интеграция с кадровым учётом',
      'Сетевые СКУД: управление через веб-интерфейс, централизованный контроль',
      'Биометрические системы: отпечатки пальцев и распознавание лиц',
      'Proximity-карты, ПИН-коды, мобильные ключи, RFID-брелоки',
      'Для отелей: интеграция с бронированием, электронные ключи',
      'Спец. считыватели с защитой от влаги и коррозии',
      'Отказоустойчивость: дублирование, локальный контроль при отключении сети'
    ],
    stats: ['400+ систем', 'Надёжность 99.99%', '0 несанкционированных проходов', 'Интеграция с PMS'],
    cta: 'Бесплатный аудит безопасности текущей СКУД.'
  },
  workplaces: {
    icon: '💼',
    title: 'Рабочие места',
    description: 'Эргономичные и технологичные рабочие места — более 2000 организовано',
    fullDescription: 'Сочетание эргономики, технологичности и эстетики. Модульная система, адаптивная под изменения. Для call-центров: временные рабочие места с быстрым развёртыванием. Рост производительности на 30%.',
    features: [
      'Эргономичная мебель: регулируемые столы и кресла',
      'Техническое оснащение: ПК, мониторы, периферия, ИБП',
      'Сетевая инфраструктура: розетки, патч-корды, Wi-Fi',
      'Комбинированное освещение: естественное и искусственное, антибликовые фильтры',
      'Акустика: шумоизоляция, акустические панели для call-центров',
      'Климат-контроль: индивидуальные настройки температуры и влажности',
      'Модульная система, адаптивная под изменения в структуре компании',
      'Кабельная система: все провода в кабельных каналах',
      'Быстрое развёртывание: увеличение операторов в 2 раза за 1 день',
      'Для гостиниц: рабочие места администраторов с интеграцией PMS'
    ],
    stats: ['2000+ рабочих мест', 'Рост производительности 30%', 'Снижение больничных 15%', 'Развёртывание за 1 день'],
    cta: 'Более 2000 организованных рабочих мест. Рост производительности на 30%.'
  },
  equipment: {
    icon: '⚙️',
    title: 'Подбор оборудования',
    description: 'Экспертный подбор и комплексные поставки IT-оборудования с гарантией 3 года',
    fullDescription: 'Услуга подбора конфигурации — БЕСПЛАТНО. Cisco Select Partner, Hikvision Authorized Partner, Dell Technologies Partner, Ubiquiti Premium Partner. Предварительная настройка — готово к работе «из коробки».',
    features: [
      'Сетевое: коммутаторы, маршрутизаторы, точки доступа (Cisco, Ubiquiti, MikroTik)',
      'Видеонаблюдение: камеры, регистраторы, ПО (Hikvision, Dahua, Axis)',
      'Телефония: IP-телефоны, АТС, гарнитуры (Yealink, Grandstream, Panasonic)',
      'Серверное: серверы, СХД, ИБП (Dell, HP, Supermicro)',
      'Автоматизация: контроллеры, датчики, исполнительные устройства',
      'СКС и кабельная продукция: кабели, патч-панели, розетки',
      'Индивидуальный подбор конфигурации под задачи клиента',
      'Проверка совместимости инженерным отделом',
      'Предварительное тестирование на собственном стенде',
      'Расширенная гарантия 3 года, замена за 24 часа'
    ],
    stats: ['Подбор БЕСПЛАТНО', 'Гарантия 3 года', '0% брака', 'Замена за 24 часа'],
    cta: 'Услуга подбора конфигурации — БЕСПЛАТНО. Гарантия 0% брака.'
  }
};

const ServicePage = ({ service }) => {
  const data = serviceData[service];
  if (!data) return <div className="service-page" style={{ textAlign: 'center', padding: '120px 20px' }}>Услуга не найдена</div>;

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="service-hero-icon">{data.icon}</div>
        <h1>{data.title}</h1>
        <p className="service-hero-desc">{data.description}</p>
        <p className="service-hero-full">{data.fullDescription}</p>
      </div>

      <div className="service-stats-wrap">
        <div className="service-stats-grid">
          {data.stats.map((stat, index) => (
            <div key={index} className="service-stat-card">
              <div className="service-stat-value">{stat}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="service-body">
        <div className="service-features-box">
          <h2>Что входит в услугу</h2>
          <div className="service-features-grid">
            {data.features.map((feature, index) => (
              <div key={index} className="service-feature-item">
                <span>✓</span>
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="service-cta">
        <p>{data.cta}</p>
        <Link to="/contact" className="service-cta-btn">Получить консультацию</Link>
      </div>
    </div>
  );
};

// Footer Component
const Footer = () => (
  <footer className="footer">
    <div className="footer-container">
      <div className="footer-grid">
        <div className="footer-col">
          <div className="footer-logo">
            <span className="footer-logo-icon">🔧</span>
            <span className="footer-logo-text">СЕТЬМОНТАЖ</span>
          </div>
          <p className="footer-description">
            Надёжные IT-решения с 2011 года. От проектирования до обслуживания сложных IT-систем.
          </p>
          <div className="footer-social">
            <a href="mailto:info@inet-sm.ru" className="social-link">✉️</a>
            <a href="tel:88006006541" className="social-link">📞</a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Услуги</h4>
          <ul>
            <li><a href="/services/hotel">Гостиничные решения</a></li>
            <li><a href="/services/networks">Сети и коммуникации</a></li>
            <li><a href="/services/automation">Автоматизация</a></li>
            <li><a href="/services/video">Видеонаблюдение</a></li>
            <li><a href="/services/wifi">Wi-Fi и HotSpot</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Контакты</h4>
          <ul>
            <li><a href="tel:88006006541">8-800-600-65-41</a></li>
            <li><a href="tel:88617654111">8 (8617) 654-111</a></li>
            <li><a href="mailto:info@inet-sm.ru">info@inet-sm.ru</a></li>
            <li><a href="mailto:support@inet-sm.ru">support@inet-sm.ru</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Режим работы</h4>
          <ul>
            <li>Пн–Пт: 10:00–17:00</li>
            <li>Сб–Вс: выходной</li>
            <li className="highlight">Аварийная служба: 24/7</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-legal">
          <span>ООО «СЕТЬМОНТАЖ» | ИНН: 2315988927 | ОГРН: 1162315051942</span>
          <span>г. Новороссийск, ул. Рубина 105, лит «У»</span>
        </div>
        <p className="footer-copyright">
          © 2011–{new Date().getFullYear()} СЕТЬМОНТАЖ. Все права защищены.
        </p>
      </div>
    </div>
  </footer>
);

export default App;
